<template>
  <div class="wrap embedded-survey-wrap">
    <Loading :visible="isLoadingPop"></Loading>
    <div class="top-header">
      <incBack></incBack>
    </div>
    <div class="body-wrap">
      <h6>안녕하세요!<br />BnB에 오신 것을 환영합니다.</h6>
      <h4>
        <span class="bold">{{ $store.state.userInfo.userName }}</span
        >님의 관심사를<br />순서대로 선택해 주세요!
      </h4>
      <span class="survey-info">3개까지 선택 가능</span>
      <div class="mt-20">
        <!-- embedded survey 부분
                (추후 bubble chart 추가 예정) -->
        <!-- <div class="hello" ref="chartdiv" style="height:500px;">
                </div> -->

        <div class="bubble clear" ref="main" id="bubble-chart">
          <div
            ref="box"
            v-for="(item, index) in circleData"
            :key="index"
            class="cirice"
            @click="clickSurvey(item, index)"
            :class="{ bg: item.isActive }"
          >
            <!-- <p>
                            <span v-if="item.isActive">{{item.order}}<br></span>{{item.text}}
                        </p> -->
            <div class="circle-wrap">
              <p>
                <span v-if="item.isActive">{{ item.order }}<br /></span
                ><b v-html="item.categorySubject"></b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bnb-btn">
      <button @click="next()" :class="{ active: isActive }">NEXT</button>
    </div>
  </div>
</template>
<script>
// import * as am4core from "@amcharts/amcharts4/core";
// import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected";
// import am4themes_animated from "@amcharts/amcharts4/themes/animated";

// am4core.useTheme(am4themes_animated);
// am4core.addLicense("ch-custom-attribution");
import incBack from "@/components/inc/inc_back.vue";
import dayjs from "dayjs";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "embedded_survey",
  data: () => ({
    circleData: [],
    activeData: [],
    totalCount: 0,
    maxCount: 3,
    hitsSquare: false,
    foundSpace: false,
    squareSize: 120,
    isActive: false,
    isLoadingPop: false,

    // depth: 카테고리 깊이(상위:1, 하위:2)
    // categoryIdxList: 등록할 카테고리 리스트 (배열 형식 배열 순서로 order 정함)
    // userIdx: 고객idx
    // courseIdx: 코스idx
    // categoryParent: 2뎁스 일경우 상위 카테고리 idx가 필요(1뎁스는 넣지 않거나 0
    input: {
      depth: 1,
      categoryIdxList: [],
      userIdx: 0,
      courseIdx: 0,
      categoryParent: 0,
      etcMemo: "",
    },
  }),
  components: {
    incBack,
    Loading,
  },
  mounted() {
    this.getEmbeddedSurvey();
  },
  methods: {
    getEmbeddedSurvey() {
      this.axios
        .get("/front/embedded-survey-list")
        .then((res) => {
          console.log(res);
          if (res.data.success) {
            let list = res.data.data;
            for (let i = 0; i < list.length; i++) {
              if (list[i].categoryDepth == "1") {
                list[i].isActive = false;
                list[i].order = 0;
                list[i].categorySubject = list[i].categorySubject.replace(
                  "(",
                  "<br>("
                );
                this.circleData.push(list[i]);
              }
            }

            if (localStorage.getItem("mainSurveyClearDate") != null) {
              let today = dayjs(new Date());
              let clear_date = dayjs(
                localStorage.getItem("mainSurveyClearDate")
              );
              if (clear_date.isBefore(today)) {
                localStorage.setItem("mainSurveyData", "");
                localStorage.setItem("mainSurveyClearDate", "");
                localStorage.setItem("subSurveyData", "");
                console.log("clear");
              } else {
                if (
                  localStorage.getItem("mainSurveyData") != "null" &&
                  localStorage.getItem("mainSurveyData") != null
                ) {
                  let survey_data = JSON.parse(
                    localStorage.getItem("mainSurveyData")
                  );
                  this.activeData = survey_data;
                  for (let i = 0; i < this.circleData.length; i++) {
                    for (let j = 0; j < this.activeData.length; j++) {
                      if (
                        this.circleData[i].categoryIdx ==
                        this.activeData[j].value
                      ) {
                        this.circleData[i].isActive = true;
                        this.circleData[i].order = j + 1;
                      }
                    }
                  }
                  this.totalCount = this.activeData.length;
                  this.isActive = true;
                  console.log("survey_data", survey_data);
                  console.log("circleData", this.circleData);
                } else {
                  this.activeData = [];
                  this.totalCount = 0;
                  this.isActive = false;
                }
              }
            } else {
              this.activeData = [];
              this.totalCount = 0;
              this.isActive = false;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    next() {
      this.isLoadingPop = true;
      // console.log(this.activeData);
      // console.log(this.activeData.length)
      if (this.activeData.length == 0) {
        alert("관심사를 선택해주세요.");
        this.isLoadingPop = false;
        return false;
      }
      this.input.categoryIdxList = [];
      for (let item of this.activeData) {
        this.input.categoryIdxList.push(item.value);
      }
      this.input.userIdx = this.$store.state.userInfo.userIdx;
      this.input.courseIdx = this.$store.state.courseInfo.courseIdx;
      let params = this.input;
      console.log(params);
      // console.log(this.input);
      this.axios
        .post("/front/embedded-survey-insert", params)
        .then((res) => {
          if (res.data.success) {
            let date = new Date();
            date.setDate(date.getDate() + 7);
            localStorage.setItem(
              "mainSurveyData",
              JSON.stringify(this.activeData)
            );
            localStorage.setItem(
              "mainSurveyClearDate",
              dayjs(date).format("YYYY-MM-DD")
            );
            this.isLoadingPop = false;
            this.$router.push("embedded_survey_subject");
          }
        })
        .catch((err) => {
          this.isLoadingPop = false;
          console.log(err);
        });
    },
    clickSurvey(item, index) {
      if (!item.isActive) {
        // console.log(this.totalCount);
        if (this.totalCount > 2) {
          alert("최대 3개까지 선택가능합니다.");
          return false;
        }
        this.totalCount++;
        item.order = this.totalCount;
        item.isActive = true;
        this.activeData.push({ value: item.categoryIdx, index: index });
        // console.log(this.circleData);
        console.log(this.activeData[0].value);
      } else {
        this.totalCount--;
        if (item.order == 1) {
          console.log(this.activeData);
          let idx = this.activeData.findIndex((itm) => {
            return itm.value == item.categoryIdx;
          });
          this.activeData.splice(idx, 1);
          if (this.activeData.length == 1) {
            this.circleData[this.activeData[0].index].order = 1;
          } else if (this.activeData.length == 2) {
            this.circleData[this.activeData[0].index].order = 1;
            this.circleData[this.activeData[1].index].order = 2;
          }
          item.isActive = false;
        } else if (item.order == 2) {
          // console.log('remove');
          let idx = this.activeData.findIndex((itm) => {
            return itm.value == item.categoryIdx;
          });
          console.log(idx);
          this.activeData.splice(idx, 1);
          console.log(this.activeData);
          if (this.activeData.length == 2) {
            this.circleData[this.activeData[1].index].order = 2;
          }
          item.isActive = false;
        } else if (item.order == 3) {
          let idx = this.activeData.findIndex((itm) => {
            return itm.value == item.categoryIdx;
          });
          this.activeData.splice(idx, 1);
          item.isActive = false;
          item.order = 0;
        }
      }
      if (this.activeData.length > 0) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
  },
};
</script>
